import { validate } from 'parameter-validator';

import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';

import { upsertPipelineSchemaLibraryMutation, buildVariables } from './upsert-pipeline-schema-library-mutation-builder';

import { GET_PIPELINE_SCHEMA_LIBRARY } from 'api/pipelines/schema-library/pipeline-schema-library-query-builder';

export default function useUpsertPipelineSchemaLibrary(options = {}) {
  const [executeMutation, response] = useMutation(upsertPipelineSchemaLibraryMutation, {
    ...options,
    refetchQueries: [GET_PIPELINE_SCHEMA_LIBRARY],
    context: { permission: permissions.createSchemas },
  });

  const upsertPipelineSchemaLibrary = args => {
    const { pipelineId, schemaLibraryVersionId } = validate(args, ['pipelineId', 'schemaLibraryVersionId']);
    // `id` is optional and deliberately read from args: validate() returns only the params it was
    // asked for, so listing it would make it required on the add path and dropping it would turn
    // every edit into an insert.
    const { id } = args;

    return executeMutation({
      variables: buildVariables({
        id,
        pipelineId,
        schemaLibraryVersionId,
      }),
    });
  };

  return [upsertPipelineSchemaLibrary, response];
}
